import { render } from "./Parents.vue?vue&type=template&id=435743a6&scoped=true"
import script from "./Parents.vue?vue&type=script&lang=js"
export * from "./Parents.vue?vue&type=script&lang=js"

import "./Parents.vue?vue&type=style&index=0&id=435743a6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-435743a6"]])

export default __exports__